<script>
import Spinner from 'shared/components/Spinner.vue';
import ReportHeader from '../ReportHeader.vue';

export default {
  name: 'MetricCard',
  components: {
    Spinner,
    ReportHeader
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col w-full mt-6 p-6 rounded-xl bg-n-solid-2 min-h-[10rem] dark:bg-n-background"
  >
    <div v-if="header" class="mb-4">
      <ReportHeader :header-title="header">
        <slot name="control" />
      </ReportHeader>
    </div>
    <div
      v-if="!isLoading"
      class="card-body max-w-full w-full ml-auto mr-auto justify-between flex"
    >
      <slot />
    </div>
    <div
      v-else-if="isLoading"
      class="items-center flex text-base justify-center px-12 py-6"
    >
      <Spinner />
      <span class="text-n-slate-12">
        {{ loadingMessage }}
      </span>
    </div>
  </div>
</template>
